import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../hooks/useApi";
import { apiClient } from "../api/client";

export function Login() {
  const navigate = useNavigate();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      const result = await login.mutateAsync({ email, password });
      apiClient.setToken(result.token);
      localStorage.setItem("user", JSON.stringify(result.user));
      navigate(result.user.role === "ADMIN" ? "/admin/overview" : "/store");
    } catch (err: any) {
      setError(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div className="auth-screen">
      <form onSubmit={handleSubmit} className="auth-card">
        <h1>Perpetual Stock</h1>
        <p className="auth-subtitle">Sign in to continue your stock workflow.</p>

        {error && <div className="auth-error">{error}</div>}

        <div className="auth-field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-input"
          />
        </div>

        <div className="auth-field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="auth-input"
          />
        </div>

        <button type="submit" disabled={login.isPending} className="auth-submit">
          {login.isPending ? "Logging in..." : "Login"}
        </button>
      </form>

      <p className="auth-hint">
        Seeded credentials are configured from environment variables during deployment.
      </p>
    </div>
  );
}